import { render, staticRenderFns } from "./BalanceHistoryHead.vue?vue&type=template&id=31649afa&scoped=true"
import script from "./BalanceHistoryHead.vue?vue&type=script&lang=js"
export * from "./BalanceHistoryHead.vue?vue&type=script&lang=js"
import style0 from "./BalanceHistoryHead.vue?vue&type=style&index=0&id=31649afa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31649afa",
  null
  
)

export default component.exports